function getBottomSuggestionPadding(): number {
    return 6;
}

export default getBottomSuggestionPadding;
